import * as Yup from 'yup';
import {string} from 'yup/lib/locale';

import {addressValidation} from 'validation/fields/address';
import {cityValidation} from 'validation/fields/city';
import {phoneNumberValidation} from 'validation/fields/phonenumber';
import {zipCanadaValidation, zipUSValidation} from 'validation/fields/zip';

export const BusinessInfoModuleValidation = Yup.object().shape(
  {
    address: addressValidation.when(['address2', 'city', 'zip', 'country'], {
      is: (address2, city, zip, country) =>
        address2 || city || zip || country?.code,
      then: Yup.string().required('Address is required'),
    }),
    address2: addressValidation,
    city: cityValidation.when(['address', 'zip', 'country'], {
      is: (address, zip, country) => address || zip || country?.code,
      then: Yup.string().required('City is required'),
    }),
    homephone: phoneNumberValidation,
    zip: Yup.string().when('country', {
      is: country => country?.code === 'CAN' || country?.code === 'USA',
      then: Yup.string().when('country', {
        is: country => country?.code === 'CAN',
        then: zipCanadaValidation,
        otherwise: zipUSValidation,
      }),
      otherwise: Yup.string(),
    }),
    state: Yup.object().when('country', {
      is: country => country?.code === 'USA',
      then: Yup.object().required('State is required'),
    }),
    province: Yup.object().when('country', {
      is: country => country?.code === 'CAN',
      then: Yup.object().required('Province is required'),
    }),
  },
  [
    ['address', 'city'],
    ['city', 'zip'],
    ['zip', 'country'],
    ['country', 'address'],
  ]
);
